import { render, staticRenderFns } from "./AscPlotBoxChart.vue?vue&type=template&id=21e68598&"
import script from "./AscPlotBoxChart.vue?vue&type=script&lang=js&"
export * from "./AscPlotBoxChart.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotBoxChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports